<template>
  <div>
    <div class="header flex-b-c">
      <div class="header-left">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" active-text-color="#409EFF">
          <el-menu-item index="2">{{ $t('cenm2') }}</el-menu-item>
          <el-menu-item index="1">{{ $t('cenm1') }}</el-menu-item>
        </el-menu>
      </div>
      <div class="header-right">
        <el-button type="primary" @click="addTheme" size="mini" round>{{ $t('nstm10') }}</el-button>
      </div>
    </div>
    <div class="main-content">
      <Theme
        v-loading="themeListLoading"
        @uploadSuccess="getThemeList"
        @editTheme="handleEditTheme"
        @openDelDialog="openDelDialog"
        @loadMore="loadMore"
       :themeList="themeList"
       :themeType="2"
      />
    </div>
    <theme-add
      :themeDialog="themeDialogVisible"
      :type="2"
      :addEdit="themeAddEdit"
      :editData="themeEditData"
      @closeThemeDialog="closeThemeDialog"
    />
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="delCloseDialog" :title="$t('nstm09')">
      <div class="dd-dialog">{{ $t('nstm08') }}</div>
    </del-dialog>
  </div>
</template>

<script>
import DelDialog from '@/components/basics/DelDialog'
import Theme from '../children/Theme'
import ThemeAdd from '../children/ThemeAdd'

export default {
  name: 'Material',
  data() {
    return {
      themeListLoading: false,
      themeList: [],
      uploadParams: {},
      activeIndex: '2',
      currentMaterialType: 2,
      themeAddEdit: "ADD",
      themeDialogVisible: false,
      themeEditData: {},
      DelDialogVisible: false,
      themeDelId: 0,
    }
  },
  methods: {
    delCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$http.post('/admin/template/deleteTheme',{
          ids: this.themeDelId,
        },() => {
          this.getThemeList();
        })
      }
      this.DelDialogVisible = false;
    },
    getThemeList(){
      this.themeListLoading = true;
      this.$http.post('/admin/template/getThemeList',{
        group_ids: this.$cookies.get('group_ids'),
        type: 2,
        material_type: this.currentMaterialType
      },data => {
        this.themeList = data || [];
        this.themeListLoading = false;
      })
    },
    loadMore(page, themeId){
      this.$http.post('/admin/template/materialList',{
        group_ids: this.$cookies.get('group_ids'),
        page,
        type: this.currentMaterialType,
        theme_id: themeId,
      },data => {
        const themeIndex = this.themeList.findIndex(item => item.id === themeId);
        if(data.data.length){
          this.themeList[themeIndex].materials.splice(this.themeList[themeIndex].materials.length, 0, ...data.data);
        }
      })
    },
    handleSelect(key) {
      this.currentMaterialType = +key;
      this.getThemeList();
    },
    handleEditTheme(theme){
      this.themeAddEdit = 'EDIT';
      this.themeEditData = {
        id: theme.id,
        name: theme.name,
        description: theme.description,
      }
      this.themeDialogVisible = true;
    },
    closeThemeDialog(isUpdate) {
      this.themeDialogVisible = false;
      isUpdate && this.getThemeList();
    },
    openDelDialog(id) {
      this.DelDialogVisible = true;
      this.themeDelId = id
    },
    addTheme() {
      this.themeAddEdit = 'ADD';
      this.themeDialogVisible = true;
    },
  },
  created() {
    this.getThemeList();
  },
  components: {
    Theme,
    ThemeAdd,
    DelDialog,
  }
}
</script>

<style lang="scss" scoped>
  .header {
    width: 100%;
    height: 60px;
      .header-left {
        margin-left: 20px;
        display: flex;
        justify-content: flex-start;
        .el-menu-demo {
          /deep/.el-menu-item{
            height: 48px;
            line-height: 48px;
          }  
         }
      }
      .header-right {
        margin-right: 20px;
      }
  }
  .main-content {
    height: calc(100% - 80px);
    padding: 0 20px;
    overflow: auto;
  }
</style>